import * as Types from '../constants/Types';

export const dataProductAction = (filters) => ({type: Types.PRODUCT_LIST_ACTION, filters});
export const dataProductSuccess = (products) => ({type: Types.PRODUCT_LIST_SUCCESS, products});

export const dataAllProductAction = () => ({type: Types.PRODUCT_LIST_ALL_ACTION});
export const dataAllProductSuccess = (allProducts) => ({type: Types.PRODUCT_LIST_ALL_SUCCESS, allProducts});

export const createProductAction = (params) => ({type: Types.PRODUCT_CREATE_ACTION, params});
export const deleteProductAction = (params) => ({type: Types.PRODUCT_DELETE_ACTION, params});

export const getUpdateProductAction = (params) => ({type: Types.PRODUCT_GET_UPDATE_ACTION, params});
export const getUpdateProductSuccess = (dataUpdate) => ({type: Types.PRODUCT_GET_UPDATE_SUCCESS, dataUpdate});

export const updateProductAction = (params) => ({type: Types.PRODUCT_UPDATE_ACTION, params});

export const createProductTranslate = (product) => ({type: Types.PRODUCT_CREATE_TRANSLATE_ACTION, product});
export const updateProductTranslate = (product) => ({type: Types.PRODUCT_UPDATE_TRANSLATE_ACTION, product});
export const deleteProductTranslate = (product, refreshParams) => ({type: Types.PRODUCT_DELETE_TRANSLATE_ACTION, product, refreshParams});